import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './TutorBasic.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import edit from'../asset/edit.png';
import { Link } from "react-router-dom";
import {Image} from 'react-bootstrap';
import {MyInput} from './Utilities/MyInput';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function TutorBasic(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [data, setData] = useState([]);
	
	const [tutors, setTutors] = useState([]);
	
	const [creatingAcc, setCreatingAcc] = useState(false);
	
	const [cUsername, setCUsername] = useState("");
	const [cPassword, setCPassword] = useState("12345678");
	
	
	const fetchData = () => {		
		getData('tutorApi/listTutor', navigate)
		.then(res => {
				setTutors(res.data);
				setFetchCompleted(true);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	const createAcc = async () => {
		setCreatingAcc(true);
		
		let obj = { username:cUsername, password:cPassword, userGroup:3 }
	
		let res = await postData("studentApi/createUser", obj, navigate); 
		fetchData();
		setCUsername("");
		setCreatingAcc(false);
	}
	
	return (<div>
	
		<div style={{display:"flex", margin:"0 10px"}}>
			<MyInput inputLabel={"Username"} dataInput={cUsername} changeAction={setCUsername} />
			<MyInput inputLabel={"password"} dataInput={cPassword} changeAction={setCPassword} />		
			<div>
				<GreenButton isEnabled={!creatingAcc} clickedAction={()=>{createAcc()}} bText={"Create"} />
			</div>
		</div>
		<div id="tutors-container">
		
			{
				tutors.map((v) => (
					<div className="tutor-holder" key={v.tutorId}>
						<div>
							<Image className="thumbnail-path" fluid
								src={`${v.profilePic}`}
								rounded onClick={()=> window.open(v.profilePic, "_blank")} />				
							<div className="tutor-id">{v.tutorId}</div>
						</div>
						<div className="tutor-detail-holder">
							<div>
								{v.displayName}					
							</div>
							<div>
									({v.username})					
							</div>
							
						</div>
							<div className="edit-logo-holder">
						
								<Link to={`/tutor/${v.tutorId}`}>
									<img className="edit-logo" src={edit} alt="icon"/>
								</Link>
						
						
							</div>
					</div>
				))
				
			}
		</div>
		</div>);
	
}

